import { Color, MeshBasicMaterial, PlaneGeometry, Mesh } from "three";
import { BasePanel } from "./BasePanel";
import VUtil from "../VUILib/VUtils.js";
import { BasicObjectType } from "../utils/Create3DObject.js";

const bg = "/assets/vrUI/common/bg.png";
const titleBgPath = "/assets/vrUI/common/titleBg.png";
const closeIconPath = "/assets/vrUI/common/close.png";
const cubeIconPath = "/assets/vrUI/basicObjectCreatePanel/cubeIcon.png";
const sphereIconPath = "/assets/vrUI/basicObjectCreatePanel/sphereIcon.png";
const cylinderIconPath = "/assets/vrUI/basicObjectCreatePanel/cylinderIcon.png";
const planeIconPath = "/assets/vrUI/basicObjectCreatePanel/planeIcon.png";
const capsuleIconPath = "/assets/vrUI/basicObjectCreatePanel/capsuleIcon.png";
const selectBgPath = "/assets/vrUI/basicObjectCreatePanel/selectBg.png";
const confirmIconPath = "/assets/vrUI/basicObjectCreatePanel/confirmIcon.png";

const btn_normalPath = "/assets/vrUI/common/btn_normal.png";
const btn_hoverPath = "/assets/vrUI/common/btn_hover.png";
const btn_clickPath = "/assets/vrUI/common/btn_click.png";

export class BasicObjectCreatePanel extends BasePanel {
  constructor(manager, visible) {
    super(manager, visible);
  }

  async init() {
    const width = 1;
    const height = 1.2;

    this.interface3D = this.manager.interface;

    // container
    const bgMap = await this.manager.loadManager.loadTexture(bg);
    const container = this.uilib.createContainer({
      color: 0x0b0c0c,
      map: bgMap,
      opacity: 1,
      width: width,
      height: height,
      radius: 0.025,
      dragable: true,
    });
    this.uilib.addUIToScene(container);
    container.visible = this._visible;
    container.position.x -= 0.5;
    //container.scale.set(0.5, 0.5, 0.5);

    this.uiElements.push(container);

    // title
    const title = this.uilib.createText({
      text: "创建模型",
      textColor: 0xafbbe3,
      textSize: 0.05,
      font: "bold",
      align: "left",
    });
    container.add(title);
    title.position.y = height / 2 - 0.08;
    title.position.x = -width / 2 + 0.08;

    // close btn
    const closeIcon = await this.manager.loadManager.loadTexture(closeIconPath);
    const closeBtn = this.uilib.createBtn({
      map: closeIcon,
      text: "",
      color: "#A8B4DB",
      width: 0.1,
      height: 0.1,
      radius: 0,
    });
    closeBtn.addHoverEnterEvent((obj) => {
      obj.material.color = new Color("#6275B5");
    });
    closeBtn.addHoverExitEvent((obj) => {
      obj.material.color = new Color("#A8B4DB");
    });
    closeBtn.addClickEvent((obj) => {
      this.closePanel();
    });
    container.add(closeBtn);
    closeBtn.position.z = 0.001;
    closeBtn.position.y = height / 2 - 0.08;
    closeBtn.position.x = width / 2 - 0.11;

    // titleBg
    this.manager.loadManager.loadTexture(titleBgPath, (tex) => {
      const titleBg = this.uilib.createImage({
        map: tex,
        width: width * 0.9,
        height: 0.1,
        radius: 0,
      });
      container.add(titleBg);
      titleBg.position.y = height / 2 - 0.1;
    });

    const cubeIcon = await this.manager.loadManager.loadTexture(cubeIconPath);
    const sphereIcon = await this.manager.loadManager.loadTexture(
      sphereIconPath
    );
    const cylinderIcon = await this.manager.loadManager.loadTexture(
      cylinderIconPath
    );
    const planeIcon = await this.manager.loadManager.loadTexture(planeIconPath);
    const capsuleIcon = await this.manager.loadManager.loadTexture(
      capsuleIconPath
    );
    const selectBg = await this.manager.loadManager.loadTexture(selectBgPath);
    const confirmIcon = await this.manager.loadManager.loadTexture(
      confirmIconPath
    );

    this.itemInfos = [
      {
        icon: cubeIcon,
        name: "立方体",
        type: BasicObjectType.Box,
      },
      {
        icon: sphereIcon,
        name: "球",
        type: BasicObjectType.Sphere,
      },
      {
        icon: cylinderIcon,
        name: "圆柱",
        type: BasicObjectType.Cylinder,
      },
      {
        icon: capsuleIcon,
        name: "胶囊",
        type: BasicObjectType.Capsule,
      },
      {
        icon: planeIcon,
        name: "平面",
        type: BasicObjectType.Plane,
      },
    ];
    this.currentSelectIndex = 0;

    const uiObjs = [];
    for (var i = 0; i < this.itemInfos.length; i++) {
      const tempContainer = this.uilib.createContainer({
        width: width * 0.9,
        height: 0.15,
        radius: 0.0,
        dragable: false,
        color: 0x2d3043,
        opacity: 0.5,
      });

      const icon = this.uilib.createImage({
        map: this.itemInfos[i].icon,
        width: 0.12,
        height: 0.12,
        radius: 0,
      });
      tempContainer.add(icon);

      icon.position.z = 0.001;
      icon.position.x = -0.25;
      // console.log(icon);
      const nameText = this.uilib.createText({
        text: this.itemInfos[i].name,
        textColor: 0xffffff,
        textSize: 0.05,
        font: "bold",
        align: "left",
      });
      tempContainer.add(nameText);
      nameText.position.z = 0.002;
      nameText.position.x = -0.1;
      tempContainer.position.z = 0.001;
      uiObjs.push(tempContainer);
      //container.add(tempContainer);
    }

    // tabcontrol
    this.tabControl = this.uilib.createTabControl({
      selectImage: selectBg,
      width: width * 0.8,
      height: 0.85,
      radius: 0.0,
      axis: "verticle",
      gap: 0.02,
      color: 0xff0000,
      opacity: 0.0,
      uiObjs: uiObjs,
      defaultIndex: this.currentSelectIndex,
      elementStateChangeColor: {
        normal: 0x2d3043,
        hover: 0xafbbe3,
        click: 0x8993c3,
      },
    });
    this.tabControl.addOnElementClickEvent((obj, index) => {
      this.onClickBtn(obj, index);
    });

    container.add(this.tabControl);
    this.tabControl.position.y = 0.02;

    // 确定按钮
    {
      const btn_normal = await this.manager.loadManager.loadTexture(
        btn_normalPath
      );
      const btn_hover = await this.manager.loadManager.loadTexture(
        btn_hoverPath
      );
      const btn_click = await this.manager.loadManager.loadTexture(
        btn_clickPath
      );

      const btn = this.uilib.createBtn({
        map: btn_normal,
        text: "",
        width: 0.25,
        height: 0.08,
        radius: 0,
        stateChangeImage: {
          normal: btn_normal,
          hover: btn_hover,
          click: btn_click,
        },
      });
      btn.addHoverEnterEvent((obj) => {});
      btn.addHoverExitEvent((obj) => {});
      btn.addClickEvent((obj) => {
        this.interface3D.createBasicObject(
          this.itemInfos[this.currentSelectIndex].type,
          (model) => {
            //console.log("创建的模型", model);
            // TODO 创建后出现在手柄？
            // 创建基本模型后自动打开场景模型面板，并选中该模型
            // this.manager.vrManager.openEditPlane("SceneModel");
            // this.manager.vrManager.setCurrentSelectModel();
          }
        );
      });
      container.add(btn);
      btn.position.z = 0.001;
      btn.position.y = -0.43;

      const icon = this.uilib.createImage({
        renderOrder: 100000,
        map: confirmIcon,
        width: 0.08,
        height: 0.08,
        radius: 0,
      });
      btn.add(icon);
      icon.position.x = -0.06;

      const text = this.uilib.createText({
        renderOrder: 100000,
        text: "确定",
        textColor: 0xafbbe3,
        textSize: 0.035,
        font: "bold",
        align: "center",
      });
      btn.add(text);
      text.position.x = 0.035;
    }

    if (!this._visible) {
      this.hide();
    }
  }

  onClickBtn(obj, index) {
    this.currentSelectIndex = index;
  }

  closePanel() {
    super.closePanel();
  }

  show() {
    super.show();
    this.manager.interface.setClickMode(9); // 切换到创建模型模式
  }
}
